import { useMapGetter } from 'dashboard/composables/store';
import { useNotificationsHubStore } from 'dashboard/stores/notificationsHub';

// Convenience wrapper so feature modules can log Hub notifications with the
// current Dotchat user pre-filled as the executor.
export const useNotificationsHub = () => {
  const store = useNotificationsHubStore();
  const currentUser = useMapGetter('getCurrentUser');

  const currentUserExecutor = () => ({
    type: 'user',
    id: currentUser.value?.id,
    name: currentUser.value?.name || 'Usuario de Dotchat',
  });

  // Logs the notification, defaulting the executor to the current user. Also
  // keeps the store aware of who is logged in so it can decide whether to fire
  // a browser/OS notification (only when the entry targets the current user).
  const logActivity = payload => {
    store.setCurrentUser(currentUser.value?.id);
    return store.log({
      ...payload,
      executor: payload.executor || currentUserExecutor(),
    });
  };

  return { store, currentUser, currentUserExecutor, logActivity };
};
